import { useTranslation } from 'react-i18next'
import StatusBar from './StatusBar'
import { TransactionCallbackStage } from '@lidofinance/lido-ethereum-sdk'
import styled from 'styled-components'

interface Props {
  stage: TransactionCallbackStage
}

const OrderProgress: React.FC<Props> = ({ stage }) => {
  const { t } = useTranslation()
  const isSuccess =
    stage === TransactionCallbackStage.DONE ||
    stage === TransactionCallbackStage.MULTISIG_DONE
  const isFailed = stage === TransactionCallbackStage.ERROR
  const label = isSuccess
    ? t('order_status_successful')
    : isFailed
    ? t('order_status_failed')
    : t('order_status_processing')
  const status = isSuccess ? 'success' : isFailed ? 'failed' : 'pending'

  return (
    <StyledTradeStatus>
      <StatusBar status={status} />
      <StyledStatusLabel>{label}</StyledStatusLabel>
    </StyledTradeStatus>
  )
}

export default OrderProgress

const StyledTradeStatus = styled.div`
  margin-top: 20px;
  padding: 16px 8px;
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.bgSurface};
`

const StyledStatusLabel = styled.p`
  margin: 16px 0 0 !important;
  font-size: 13px;
  font-weight: 500;
  line-height: 13px;
  text-align: right;
  color: ${({ theme }) => theme.colors.textDisabled};
`
